import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import {
    mapData,
    converTime,
    getPickupHours,
} from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import moment from 'moment'

const DisapprovalReasonManagement = (props) => {
    const settingcontext = useContext(SettingContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const [isDisable, setIsDisable] = useState(true)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        admin_reason_text: Yup.string().required('Required!'),
        email_text: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            status: 'open',
            admin_reason_text: '',
            email_text: '',
            global_publisher: true,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (!values?.id) {
                values.date_added = new Date() // Correctly create a new Date object
            }

            values.table = 'disapproval_reason'
            values.global_publisher = true

            values.updateDisapproval = true
            if (isDisable) {
                setIsDisable(false)
                searchTableAction(values, false, 'disapproval_create')
            }
        },
    })

    useEffect(() => {
        if (responseStatusSetting) {
            setIsDisable(true)
            if (
                responseStatusSetting.from === 'disapproval_create' &&
                responseStatusSetting.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                formik.resetForm()
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (data.status != 'new') {
            formik.setFieldValue('id', data.id)
            const template =
                props?.record?.find((cat) => cat.id === data.id) || {}

            formik.setValues({
                ...formik.values,
                ...template,
            })
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,
            status: 'open',
            admin_reason_text: '',
            email_text: '',
        })
    }

    const details = {
        formik: formik,
        data: [
            {
                label: 'Admin Reason Text',
                placeholder: 'Enter Admin Reason Text',
                type: '',
                required: true,
                class: 'col-6',
                name: 'admin_reason_text',
            },
            {
                label: 'Email Text',
                placeholder: 'Enter Email Text',
                type: '',
                class: 'col-6',
                name: 'email_text',
            },
        ],
    }

    const submitFunction = () => {
        formik.handleSubmit()
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'Add New Disapproval Reason'
                    : 'Edit Disapproval Reason'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    <div className="row">{mapData(details)}</div>

                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                    {/* </form> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default DisapprovalReasonManagement
